import React, {Suspense, Component, useState, useEffect} from "react";
import {
    ATTR_CREATED_MS_I,
    ATTR_CUSTOMER_GROUP,
    ATTR_NOTIFICATION_FOR_NEW_SUBPROJECTS, ATTR_RULE_NOTIFICATION_RECURRING_DAY, ATTR_RULE_NOTIFICATIONS,
    ATTR_SELECTED_REPORTS,
    ATTR_UI_SEARCH,
    ATTR_UI_SETTINGS,
    ATTR_UI_VIEW_MODE,
    ATTR_UPDATED_MS_I,
    awaitMakeProjectLink,
    deepCopyObj, getDisclaimerWhyDisabled, isProjectArchived,
    OBJ_STATE_TO_DEL,
    prosLogErr,
    replaceAll,
    STR_NO,
    STR_NO_VALUE,
    STR_YES,
    strToBool,
    TEXT_FIELD_TYPE_EMAIL,
    TEXT_FIELD_TYPE_EMAILS,
    textToShow,
    VIEW_MODE_TABLE,
    millisecToDatePicker, datePickerReturnValueToMillisec, isValueEmpty, ATTR_RULE_PROJECTS
} from "../prodect/ProsConnect";
import BasicButton, {CancelButton, ConfirmButton}  from "../components/BasicButton";
import ToggleSwitch from "../components/ToggleSwitch";
import * as prosConnect from "../prodect/ProsConnect";
import {formatDate, QuickHelpButton, isValidEmail, getEndOfWorkingDayTimeMs} from "../prodect/ProsCommonUi";
import TextInput from "../components/TextInput";
import Checkbox from "../components/Checkbox";
import Spacer from "../components/Spacer";
import prosAppNotif, {prosAppNotifWarn} from "../prodect/ProsAppNotif";
import {setHelpContext} from "../prodect/HelpManager";
import LinkFilters from "../components/LinkFilters"
import DropdownMenu from "../components/DropdownMenu";
import LoadingAnimation from "../components/LoadingAnimation";
import DatePicker from "../components/DatePicker";
import {MAIN_VIEW_SETTINGS} from "./Home";
import {USE_DEVELOPMENT_FEATURES} from "../config";
import TextButton from "../components/TextButton";
import {ISO_WEEKDAYS} from "./Settings";
import ProgressSteps from "../components/ProgressSteps";

const RULE_TYPE_TRIGGERED = 'triggered'
const RULE_TYPE_RECURRING = 'recurring'

const RULE_TEMPLATE = {
    obj_type: 'notif_rule',
    text: '',
    comment: '',
    in_use: STR_YES,
    rule_type: RULE_TYPE_TRIGGERED, // recurring, triggered
    to_all_users: STR_NO,
    to_emails: [],
    to_txts: [],
    // to_tags: [],    todo later when mapping MV option with email list
    to_creator: STR_NO,
    to_updater: STR_NO,
    to_muted: [],
    trig_created: STR_NO,
    trig_deleted: STR_NO,
    trig_updated: STR_NO,
    trig_item_created: STR_NO,
    trig_item_deleted: STR_NO,
    trig_item_updated: STR_NO,
    trig_expiry_changed: STR_NO,
    trigger_attr_changed: [],
    send_week_calendar: STR_NO,
    delay_minutes: 0,
    delay_minutes_minimum: 5,
    stat_emails_sent: 0,
    stat_receivers: [],
}

const DEMO_RULES = [
    {
        text: 'Myöhässä',
        comment: 'Tämä sääntö lähettää ilmoituksen kirjauksen tekijälle ja muokkaajille kun määräaika on erääntynyt ja tila on kesken.',
        rule_type: RULE_TYPE_RECURRING,
        to_creator: STR_YES,
        to_updater: STR_YES,
        template_ui_settings: {
            filters: [
                {value: ['day', '', '-1'], id: 'ui_timeToDate'}
            ],
            'viewMode': VIEW_MODE_TABLE,
        },
    },
    {
        text: 'Määräaika lähestyy',
        comment: 'Tämä sääntö lähettää ilmoituksen kirjauksen tekijälle ja sen muokkaajille kun määräaika erääntyy seuraavan viikon sisällä ja tila on kesken.',
        rule_type: RULE_TYPE_RECURRING,
        to_creator: STR_YES,
        to_updater: STR_YES,
        template_ui_settings: {
            filters: [
                {value: ['day', '0', '7'], id: 'ui_timeToDate'}
            ],
            'viewMode': VIEW_MODE_TABLE,
        },
    }
]

const RULE_TYPES = [
    {
        text: 'Muutosilmoitus',
        value: RULE_TYPE_TRIGGERED
    },
    {
        text: 'Toistuva ilmoitus',
        value: RULE_TYPE_RECURRING
    }
]

export default class NotificationRules extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notificationRules: [],
            editing: undefined,
            show_trigger_attrs: false,
            allow_force: false,
            trigger_notif_allowed: true,
            recurring_notif_allowed: true,
            recurring_notif_day: 1,
            project_allowed: true,
        }
    }

    componentDidMount() {
        this.checkUserPermissions()
        this.updateNotificationRules()
        setHelpContext('notificationRules')
    }

    async updateNotificationRules() {
        let rules = await prosConnect.getNotificationRules(prosConnect.getActiveProjectID()) ?? []
        rules = rules?.rules ?? []
        this.setState({
            notificationRules: rules
        })
        this.checkToContinueAfterFilterEdit(rules)
        return rules
    }

    async checkUserPermissions() {
        let trigger_notif_allowed = true
        let recurring_notif_allowed = true
        let recurring_notif_day = 1
        let project_allowed = true
        let notif_settings = await prosConnect.getUserNotifSettings()
        if (notif_settings === {}) {
            return
        }
        if (ATTR_RULE_NOTIFICATIONS in notif_settings && ! notif_settings[ATTR_RULE_NOTIFICATIONS]) {
            trigger_notif_allowed = false
        }
        if (ATTR_RULE_NOTIFICATION_RECURRING_DAY in notif_settings) {
            recurring_notif_day = notif_settings[ATTR_RULE_NOTIFICATION_RECURRING_DAY]
            if ( ! notif_settings[ATTR_RULE_NOTIFICATION_RECURRING_DAY]) {
                recurring_notif_allowed = false
                recurring_notif_day = 0
            }
        }
        if (! (ATTR_RULE_PROJECTS in notif_settings) ||
            ! Array.isArray(notif_settings[ATTR_RULE_PROJECTS]) ||
            notif_settings[ATTR_RULE_PROJECTS].includes(prosConnect.getActiveProjectID()) === (notif_settings[ATTR_NOTIFICATION_FOR_NEW_SUBPROJECTS] ?? false)) {
            project_allowed = false
        }
        this.setState({
            allow_force: prosConnect.isCustomerHeadAdmin(),
            trigger_notif_allowed: trigger_notif_allowed,
            recurring_notif_allowed: recurring_notif_allowed,
            recurring_notif_day: recurring_notif_day,
            project_allowed: project_allowed,
        })
    }

    checkToContinueAfterFilterEdit() {
        if (this.props.continueAfterEditLinkRule) {
            this.setState({editing: this.props.continueAfterEditLinkRule})
            this.props.clearContinueAfterEditLinkRule()
        }
    }

    async handleAddNewRule(templateRule = undefined) {
        let tempId = prosConnect.currentTimeMs()
        let newRule = deepCopyObj(RULE_TEMPLATE)
        if (templateRule) {
            newRule = Object.assign({}, newRule, templateRule)
            delete newRule.template_ui_settings
        }
        newRule.project_id = prosConnect.getActiveProject().getPid()
        newRule.uniqueId = tempId
        let rulesAfterAdding = await this.saveRuleChanges(newRule)
        let ruleFromServer = rulesAfterAdding.find(rule => rule.uniqueId === tempId)
        if (!ruleFromServer) {
            prosLogErr("Failed to create rule:", newRule)
            prosAppNotifWarn("Hmm.. uuden säännön luonti epäonnistui")
        }
        if (templateRule) {
            let linkUuId = prosConnect.getRuleLinkId(ruleFromServer)
            let req = prosConnect.makeLinkRequest()
            req[ATTR_SELECTED_REPORTS] = prosConnect.getActiveProject().getReports(true).map(report => report.obj_id)
            req[ATTR_UI_VIEW_MODE] = 'table'
            req[ATTR_UI_SEARCH] = false
            req[ATTR_UI_SETTINGS] = templateRule.template_ui_settings
            let linkId = await awaitMakeProjectLink(true, linkUuId, req)
            if ( ! linkId) {
                prosAppNotif('fail')
            }
        }
        this.setState({editing: ruleFromServer})
    }

    requestNotifForCustomer(recurring = false) {
        prosConnect.requestNotifForCustomer(prosConnect.getActiveProject().getAttr(ATTR_CUSTOMER_GROUP), recurring)
        prosAppNotif('Testi ilmoitus pyydetty')
    }

    editRule(editRule) {
        this.setState({editing: editRule})
    }

    cancelEditing() {
        this.setState({editing: undefined})
        setHelpContext('notificationRules')
    }

    async saveRuleChanges(rule) {
        await prosConnect.saveNotificationRule(rule.project_id, rule)
        this.setState({editing: undefined})
        return await this.updateNotificationRules()
    }

    async removeRule(rule) {
        rule.obj_state = OBJ_STATE_TO_DEL
        await this.saveRuleChanges(rule)
    }

    renderAddNewRuleButton(label, btnType, rule){
        let whyNotAllowed = getDisclaimerWhyDisabled("addContent", rule)
        return <BasicButton
            btnClass={btnType}
            label={label}
            icon={"plus"}
            action={()=> this.handleAddNewRule(rule)}
            disabled={whyNotAllowed}
            tooltip={whyNotAllowed ? [whyNotAllowed]: null}
        />
    }

    renderAddNewRule() {
        return <div className={"btn-set"}>
            {this.renderAddNewRuleButton('Uusi ilmoitus' ,'primary')}
        </div>
    }

    renderTestNotificationsForCustomer() {
        if (prosConnect.isSuperUserModeInUse() || USE_DEVELOPMENT_FEATURES) {
            return <div className={"btn-set margin-top"}>
                <BasicButton
                    btnClass={"2nd"}
                    label={"Test-Notif"}
                    icon={"plus"}
                    action={() => {this.requestNotifForCustomer()}}
                    disabled={isProjectArchived()}
                />
                <BasicButton
                    btnClass={"2nd"}
                    label={"Test-Notif-Recurring"}
                    icon={"plus"}
                    action={() => {this.requestNotifForCustomer(true)}}
                    disabled={isProjectArchived()}
                />
            </div>
        }
        return ''
    }

    /**
     * @param {React.FormEvent} e
     */
    handleSubmitSaveRule = (e) => {
        e.preventDefault()
        this.saveRuleChanges(this.state.editing)
    }

    renderRuleEditing(rule) {
        return <>
            <h1 className={"element-set"}>Muokkaa ilmoitusta
                <div className={"flex-grow btn-set_right"}>
                    <BasicButton
                        btnClass={"primary"}
                        label={"Takaisin"}
                        icon={"arrow-left"}
                        action={()=> this.cancelEditing()}
                    />
                </div>
            </h1>
            <section>
                <form id="notificationRuleSettingsForm" onSubmit={this.handleSubmitSaveRule}>
                    <Suspense fallback={<LoadingAnimation text="Ladataan..."/>}>
                        <RuleSettings
                            rule={rule}
                            editTableLinkSettings={this.props.editTableLinkSettings}
                            setMainView={this.props.setMainView}
                        />
                    </Suspense>
                </form>
            </section>
            <footer className={"page-footer"}>
                <div className="btn-set_center">
                    <CancelButton
                        action={()=> this.cancelEditing()}
                    />
                    <button
                        type="submit"
                        form={"notificationRuleSettingsForm"}
                        className={"btn btn-primary btn-confirm btn-icon btn-icon-left"}
                    >
                        <span>Tallenna</span>
                    </button>
                </div>
            </footer>
        </>
    }

    renderFooterStatus(rule){
        return <>
            <span className={"icon-text-set-xs text-sm"}>
                <i className={"ui-icon ui-icon-" + (strToBool(rule.in_use) ? "check ui-icon_color-ok" : "cancel ui-icon_color-no")} />
                {strToBool(rule.in_use) ? "Aktiivinen" : "Ei aktiivinen"}
                {!strToBool(rule.in_use) && !isValueEmpty(rule.forced_until) ? <span className={"msg msg-warning text-sm padding-sm margin-left bg-color-2nd color-light"} data-tooltip={"Pääkäyttäjä pystyy pakottamaan viestin lähetyksen."}>
                <span className={"dom-show-block"}>Pakotettu {formatDate(rule.forced_until)} asti.<br/>{rule.forced_by}</span>
            </span> : null}
            </span>
        </>
    }

    renderRuleFooter(rule, isDemo){
        let whyNotAllowed = getDisclaimerWhyDisabled("editObj", rule)
        return <footer className={"display-flex"}>
            {!isDemo ? <div className={"element-set-sm flex-wrap valign-center"}>
                {this.renderFooterStatus(rule)}
                </div> : null}
            {!isDemo ? <div className={"btn-set"}>
                <BasicButton
                    btnClass={"2nd"}
                    icon={"edit"}
                    action={() => {this.editRule(rule)}}
                    disabled={whyNotAllowed}
                    tooltip={whyNotAllowed ? [whyNotAllowed]: null}
                />
                <ConfirmButton
                    btnClass={"2nd"}
                    action={()=>{
                        this.removeRule(rule)
                        prosAppNotif("Sääntö poistettu")
                    }}
                    confirmAction
                    hideLabel
                    btnType={"fatal"}
                    disabled={whyNotAllowed}
                    tooltip={whyNotAllowed ? [whyNotAllowed]: null}
                />
                </div> : <div className={"btn-set_right"}>
                        {this.renderAddNewRuleButton('Lisää ilmoitus', '2nd', rule)}
                </div>}
        </footer>
    }

    renderRule(rule, i, isDemo) {
        return <div key={"rule" + i} className={"inpage-box"}>
            <header className={"element-set"}>
                <h4 className={"flex-grow margin-0"}>{textToShow(rule.text)}</h4>
                <h6 className={"margin-0 color-gray-60"}>{RULE_TYPES.find(
                    r_type => r_type.value === (rule.rule_type ?? RULE_TYPE_TRIGGERED)
                ).text.toUpperCase()}</h6>
            </header>
            <section>
                {!isDemo ? <div className={"element-set"}>
                    <p className={"flex-grow"}>Vastaanottajia <strong>{rule.stat_receivers.length}</strong></p>
                    <p>Lähetetty <strong>{rule.stat_emails_sent}</strong> kertaa</p>
                </div> : null}
                {rule.comment !== STR_NO_VALUE ? <div className={"element-set"}>
                        <p className={"text-sm"}>{textToShow(rule.comment)}</p>
                    </div> : isDemo ? <Spacer/> : null}
            </section>
            {this.renderRuleFooter(rule, isDemo)}
        </div>
    }

    renderOwnNotifSettings() {
        const recur_day = ISO_WEEKDAYS.slice(1).find(val => this.state.recurring_notif_day === val.value)
        return <div className={"msg msg-info msg-notification-rules width-100 width-auto_md"}>
            <h3>Omat viestintäasetukset</h3>
            <ul className={"list-no-style"}>
                <li className={"icon-text-set-xs"}><i className={"ui-icon ui-icon-" + (this.state.trigger_notif_allowed ? "check ui-icon_color-ok" : "cancel ui-icon_color-no")}/></li><li>Muutosilmoitusten lähettäminen</li>
                <li className={"icon-text-set-xs"}><i className={"ui-icon ui-icon-" + (this.state.recurring_notif_allowed ? "check ui-icon_color-ok" : "cancel ui-icon_color-no")}/></li><li>Toistuvien ilmoitusten lähettäminen</li>
                <li className={"icon-text-set-xs"}><i className={"ui-icon ui-icon-" + (this.state.project_allowed ? "check ui-icon_color-ok" : "cancel ui-icon_color-no")}/></li><li>Tämän projektin ilmoitukset</li>
            </ul>
            <p>Toistuvat ilmoitukset lähetetään <strong>{(recur_day ? recur_day.text : 'Maanantai').toLowerCase()}na.</strong></p>
            <p>Muokkaa asetuksia omissa <span className={"lnk"} onClick={()=> this.props.setMainView(MAIN_VIEW_SETTINGS)}>viestintäasetuksissa</span></p>
        </div>
    }

    renderNotificationRules() {
        const demoRules = DEMO_RULES
        const activeRules = this.state.notificationRules.filter(rule =>  rule.in_use === STR_YES || !isValueEmpty(rule.forced_until))
        const inActiveRules = this.state.notificationRules.filter(rule => rule.in_use === STR_NO && isValueEmpty(rule.forced_until))
        return <>
            <h1>Ilmoitukset</h1>
            <section>
                <div className={"slab page-top_notif-rules display-flex"}>
                    <div className={"width-100 width-50_md"}>
                        <p>Tällä sivulla luodaan ja muokataan sähköpostilla osaprojektin käyttäjille lähetettäviä ilmoituksia.<br/>
                        Katso myös käyttajäkohtaiset <span className={"lnk"} onClick={()=> this.props.setMainView(MAIN_VIEW_SETTINGS)}>viestintäasetukset</span> ja <span className={"lnk"} onClick={()=> this.props.toggleShowingHelpDesk()}>ohje</span>.</p>
                    </div>
                    <div className={"width-100 width-50_md"}>
                        {this.renderOwnNotifSettings()}
                    </div>
                </div>
                <h2>Valmispohjat</h2>
                <div className="slab grid-container grid-1 grid-2_lg grid-3_xxl grid-4_hd demo-rules">
                    {demoRules.map((rule, i) => {
                        return this.renderRule(rule, i, true)
                    })}
                </div>
                {activeRules.length > 0 ? <>
                    <h3>Käytössä</h3>
                    <div className="slab grid-container grid-1 grid-2_lg grid-3_xxl grid-4_hd">
                        {activeRules.map((rule, i) => {
                            return this.renderRule(rule, i, false)
                        })}
                    </div>
                </> : null}
                <div className="slab">
                    {this.renderAddNewRule()}
                </div>
                {inActiveRules.length > 0 ? <>
                    <Spacer line size={"xl"}/>
                    <h3>Ei käytössä</h3>
                    <div className="slab grid-container grid-1 grid-2_lg grid-3_xxl grid-4_hd">
                        {inActiveRules.map((rule, i) => {
                            return this.renderRule(rule, i, false)
                        })}
                    </div>
                    </> : null}
                <div className="slab">
                    {this.renderTestNotificationsForCustomer()}
                </div>
            </section>
        </>
    }

    render() {
        if (this.state.editing) {
            return this.renderRuleEditing(this.state.editing)
        }
        return this.renderNotificationRules()
    }
}

export const RuleSettings = (props) => {
    const { rule } = props
    const project = prosConnect.getActiveProject()
    const allow_force = prosConnect.isCustomerHeadAdmin()

    const [emailTags] = useState(getEmailTags(true))
    const [txtTags] = useState(getEmailTags(false))
    const [yesNoTags] = useState(getYesNoTags())
    const [multiSelectTags] = useState(getMultiSelectTags())

    const [toTagsSelected, setToTagsSelected] = useState(rule.to_txts ?? [])
    const [changeTagsSelected, setChangeTagsSelected] = useState(rule.trigger_attr_changed ?? [])

    const [progressStep, setProgressStep] = useState(1)
    const progressSteps = 3

    const [showTriggerAttrs, setShowTriggerAttrs] = useState( ! strToBool(rule.trig_updated))
    const [ruleType, setRuleType] = useState(rule.rule_type ?? RULE_TYPE_TRIGGERED)

    const [toggleRefreshState, setToggleRefreshState] = useState(false)

    useEffect(() => {
        // Called once when edit notif settings UI component created
        if (rule.text !== STR_NO_VALUE) {
            setProgressStep(2)
        }
        if (strToBool(rule.to_creator)
            || strToBool(rule.to_updater)
            || strToBool(rule.to_all_users)
            || rule.to_emails.length !== 0
            || rule.to_txts.length !== 0
        ) {
            setProgressStep(3)
        }
        setHelpContext('notificationRuleEdit')
    }, [
        rule.text,
        rule.to_all_users,
        rule.to_creator,
        rule.to_emails.length,
        rule.to_txts.length,
        rule.to_updater
    ])

    /**
     * Get email tags - either all or those that are of type email/emails
     * @returns {*[]} list of {tagId: <>, label: <> }
     */
    function getEmailTags(emailOnly) {
        return project.getFreeTextContent()
            .tags
            .filter(tag => tag.inUse)
            .filter(tag => !emailOnly ||
                tag.textType === TEXT_FIELD_TYPE_EMAIL ||
                tag.textType === TEXT_FIELD_TYPE_EMAILS)
            .map(tag => { return {
                tagId: tag.stag.substring(1),
                label: tag.label
            }})
    }

    /**
     * Get email tags - either all or those that are of type email/emails
     * @returns {*[]} list of {tagId: <>, label: <> }
     */
    function getYesNoTags() {
        return project.getOnOffContent()
            .tags
            .filter(tag => tag.inUse)
            .map(tag => { return {
                tagId: tag.stag.substring(1),
                label: tag.label
            }})
    }

    function getMultiSelectTags() {
        let rbTags = []
        let tagCount = project.getRbTagsS().length
        for (let rgInd = 0; rgInd < tagCount; rgInd++) {
            let mvTag = project.getMvTagSettings(rgInd)
            if (mvTag.inUse) {
                rbTags.push({
                    tagId: mvTag.stag.substring(1),
                    label: mvTag.label,
                })
            }
        }
        return rbTags
    }

    function selectToTag(tag) {
        const selectedTags = toTagsSelected.find(t => t === tag)
            ? toTagsSelected.filter(t => t !== tag)
            : [tag, ...toTagsSelected]
        setToTagsSelected(selectedTags)
        setProgressStep(3)
        rule.to_txts = selectedTags
    }

    function selectChangeTag(tag) {
        const selectedTags = changeTagsSelected.find(t => t === tag)
            ? changeTagsSelected.filter(t => t !== tag)
            : [tag, ...changeTagsSelected]
        setChangeTagsSelected(selectedTags)
        rule.trigger_attr_changed = selectedTags
    }

    function renderToTagSelector(tag) {
        const isSelected = toTagsSelected.find(t => t === tag.tagId)
        return <BasicButton
            key={"to:" + tag.tagId}
            btnClass={"2nd"}
            label={tag.label}
            icon={isSelected ? "check" : null}
            selected={isSelected}
            action={() => selectToTag(tag.tagId)}
        />
    }

    function renderChangeTagSelector(tag) {
        const isSelected = changeTagsSelected.find(t => t === tag.tagId)
        return <React.Fragment key={tag.tagId}>
            <Checkbox
                defaultChecked={strToBool(isSelected)}
                text={tag.label}
                onChange={() => {
                    selectChangeTag(tag.tagId)
                }}
            />
        </React.Fragment>
    }

    function renderTagChanged(title, tags) {
        if (!tags.length) {
            return null
        }
        return <div>
            <h6>{title}</h6>
            <div className={"selection-group selection-group-check"}>{tags.map(tag => renderChangeTagSelector(tag))}</div>
        </div>
    }

    function renderDumpButton() {
        if (!prosConnect.isSuperUserModePossible()) {
            return null
        }
        return <BasicButton
            btnClass={"2nd"}
            label={"test_dump"}
            icon={"plus"}
            action={() => console.log(rule)}
        />
    }

    async function openTableToEditFilters() {
        let linkId = prosConnect.getRuleLinkId(rule)
        if (linkId) {
            await prosConnect.saveNotificationRule(project.getPid(), rule)
            props.editTableLinkSettings(project.getPid(), linkId, rule)
        } else {
            prosLogErr("Link not found for rule", rule)
            prosAppNotifWarn("Hmm - linkkiä ei löytynyt")
        }
    }

    function renderTableFiltering() {
        return <>
            <h4>Lisäehdot</h4>
            <p>Rajaa ja tarkastele ilmoituksen tietosisältöä taulukon avulla.</p>
            <LinkFilters
                linkId = {prosConnect.getRuleLinkId(rule)}
            />
            <BasicButton
                btnClass={"2nd"}
                label={"Taulukko-suodatus"}
                icon={"funnel"}
                action={() => openTableToEditFilters()}
            />
        </>
    }

    function toggleBoolean(val) {
        return val === STR_YES ? STR_NO : STR_YES
    }

    function emaiListToText(emailList) {
        if (Array.isArray(emailList)) {
            return emailList.join(",")
        }
        // Tolerate in test environment a string list
        return textToShow(emailList)
    }

    function renderReceivers() {
        if (progressStep < 2) {
            return null
        }
        //Todo this validation doesnt work correctly because how the data is saved
        //isValid and required combo doens't work on this page
        //let isValid = isMultipleEmailsValid(rule.to_emails.join(','))
        return <>
            <Spacer line/>
            <h2>Vastaanottajat</h2>
            <div className={"slab grid-container grid-1 grid-2_xl"}>
                <div className={"selection-group selection-group-check"}>
                    <Checkbox
                        defaultChecked={strToBool(rule.to_all_users)}
                        text="Lähetä ilmoitus kaikille osaprojektin käyttäjille"
                        onChange={() => {
                            setProgressStep(3)
                            rule.to_all_users = toggleBoolean(rule.to_all_users)
                        }}
                    />
                    <Checkbox
                        defaultChecked={strToBool(rule.to_creator)}
                        text="Lähetä ilmoitus kirjauksen tekijälle"
                        onChange={() => {
                            setProgressStep(3)
                            rule.to_creator = toggleBoolean(rule.to_creator)
                        }}
                    />
                    <Checkbox
                        defaultChecked={strToBool(rule.to_updater)}
                        text="Lähetä ilmoitus niille, jotka ovat muokanneet kirjausta"
                        onChange={() => {
                            setProgressStep(3)
                            rule.to_updater = toggleBoolean(rule.to_updater)
                        }}
                    />
                    {emailTags.length ? <>
                            <Spacer size={"lg"}/>
                            <h4>Vastaanottajat asetuksista</h4>
                            <div className={"btn-set flex-wrap margin-bottom"}>
                                {emailTags.map(emailTag => renderToTagSelector(emailTag))}
                            </div>
                        </>
                        : null}
                </div>
                <div>
                    <h3>Muut vastaanottajat</h3>
                    <TextButton
                        label={(rule.to_emails.length < 1 ? "Lisää" : "Muokkaa") + " vastaanottajia"}
                        //icon={rule.to_emails.length < 1 ? "plus" : "edit"}
                        value={emaiListToText(rule.to_emails)}
                        placeholder={"Aseta vastaanottajat"}
                        onChange={val => {
                            setProgressStep(3)
                            const emails = replaceAll(val, ",", ";")
                            rule.to_emails = emails ? emails.split(';').filter(eml=> isValidEmail(eml, true)) : []
                            setToggleRefreshState(!toggleRefreshState)
                        }}
                        isActive={rule.to_emails.length > 0}
                        //required={!isValid}
                        //isValid={isValid}
                        info={"Kirjoita vastaanottajien emailit pilkulla eroteltuna"}
                    />
                    <Spacer/>
                </div>
            </div>
        </>
    }

    function renderSendingRules() {
        if (ruleType !== RULE_TYPE_TRIGGERED) return null
        return <div>
                <p>Lähetä ilmoitus kun jokin seuraavista ehdoista täyttyy</p>
                <div className={"selection-group selection-group-check"}>
                    <Checkbox
                        defaultChecked={strToBool(rule.trig_created)}
                        text="Kirjaus lisätty"
                        onChange={() => {
                            rule.trig_created = toggleBoolean(rule.trig_created)
                        }}
                    />
                    <Checkbox
                        defaultChecked={strToBool(rule.trig_item_created)}
                        text="Kuva tai kommentti lisätty tai poistettu"
                        onChange={() => {
                            rule.trig_item_created = toggleBoolean(rule.trig_item_created)
                        }}
                    />
                </div>
                <h4 className={"margin-top"}>Muutokset</h4>
                <ToggleSwitch
                    label={"Mikä tahansa tieto muuttunut"}
                    defaultChecked={strToBool(rule.trig_updated)}
                    onChange={() => {
                        rule.trig_updated = toggleBoolean(rule.trig_updated)
                        setShowTriggerAttrs(!showTriggerAttrs)
                    }}
                />
                {renderPartialDataTriggers()}
            </div>
    }

    function renderForceButton(){
        const minDate = millisecToDatePicker(new Date(Date.now()))
        const maxDate = millisecToDatePicker(new Date(Date.now() + 1000 * 60 * 60 * 24 * (7 * 8)))//7 * 8 = 8 weeks
        return <div>
            <h6>Ohita käyttäjän asetukset <QuickHelpButton position={"right"} field={'forceNotif'} /></h6>
            <div className={"btn-set"}>
                <DatePicker
                    label={isValueEmpty(rule.forced_until) ? 'Aseta aika' : 'Muokkaa'}
                    value={isValueEmpty(rule.forced_until) ? '' : millisecToDatePicker(rule.forced_until)}
                    onChange={(evt)=>{
                        rule.forced_until = !isValueEmpty(evt.target.value) ? getEndOfWorkingDayTimeMs(datePickerReturnValueToMillisec(evt.target.value)) : STR_NO_VALUE
                        rule.forced_by = prosConnect.getUserEmail(true)
                        if(isValueEmpty(evt.target.value)) rule.forced_recurring_day = 0
                        setToggleRefreshState(!toggleRefreshState)
                    }}
                    minDate={minDate}
                    maxDate={maxDate}
                />
                {rule?.rule_type === RULE_TYPE_RECURRING && !isValueEmpty(rule.forced_until)
                    ? <div className={"element-set-v-sm"}>
                            <p className={"margin-0"}>Aseta lähetyspäivä</p>
                            <DropdownMenu
                                text={"Valitse"}
                                values={[
                                    {text: 'Käyttäjän valinta', value: 0},
                                    {text: 'Maanantai', value: 1},
                                    {text: 'Tiistai', value: 2},
                                    {text: 'Keskiviikko', value: 3},
                                    {text: 'Torstai', value: 4},
                                    {text: 'Perjantai', value: 5},
                                    {text: 'Lauantai', value: 6},
                                    {text: 'Sunnuntai', value: 7},
                                ]}
                                currentValue={rule.forced_recurring_day}
                                onSelect={val => {
                                    rule.forced_recurring_day = val
                                    rule.forced_by = prosConnect.getUserEmail(true)
                                    setToggleRefreshState(!toggleRefreshState)
                                }}
                            />
                        </div>
                        : null}
            </div>
        </div>
    }

    function renderTriggers() {
        if (progressStep < 3) {
            return null
        }
        return <>
            <Spacer line/>
            {ruleType === RULE_TYPE_TRIGGERED ? <h2>Lähetys<QuickHelpButton position={"right"} field={'notifSend'} /></h2> : null}
            <div className={"slab grid-container grid-1 grid-2_xl"}>
                {renderSendingRules()}
                <div>
                    <div>{renderTableFiltering()}</div>
                    <div className={"margin-top"}>{renderDumpButton()}</div>
                </div>
                {allow_force
                    ? renderForceButton()
                    : null
                }
            </div>
        </>
    }

    function renderPartialDataTriggers(){
        if(!showTriggerAttrs) return null
        return <div className={"element-indented margin-top"}>
            {/*En saanut nakymaa paivittymaan Buttonilla*/}
            {/*<BasicButton*/}
            {/*    btnClass={"2nd"}*/}
            {/*    label={"Määräaika muutettu"}*/}
            {/*    icon={"alarm"}*/}
            {/*    selected={strToBool(rule.trig_expiry_changed)}*/}
            {/*    // hilite={strToBool(rule.trig_expiry_changed)}*/}
            {/*    action={()=> {*/}
            {/*        rule.trig_expiry_changed = toggleBoolean(rule.trig_expiry_changed)*/}
            {/*    }}*/}
            {/*    className={"margin-bottom"}*/}
            {/*/>*/}
            <Checkbox
                defaultChecked={strToBool(rule.trig_expiry_changed)}
                text="Määräaika muutettu"
                onChange={() => {
                    rule.trig_expiry_changed = toggleBoolean(rule.trig_expiry_changed)
                }}
            />
            <div className={"grid-container grid-2"}>
                {renderTagChanged("Kyllä/ei valinnat", yesNoTags)}
                {renderTagChanged("Tekstikentät", txtTags)}
                {renderTagChanged("Monivalinnat", multiSelectTags)}
            </div>
        </div>
    }

    return <>
        <div className={"slab grid-container grid-1 grid-2_xl"}>
            <div className={"element-set"}>
                <div className={"element-set-v-sm"}>
                    <span>Tyyppi<QuickHelpButton field={'notifType'} /></span>
                    <DropdownMenu
                        text={"Valitse tyyppi"}
                        values={RULE_TYPES}
                        currentValue={rule.rule_type || RULE_TYPE_TRIGGERED}
                        onSelect={(val)=>{
                            rule['rule_type'] = val
                            setRuleType(val)
                        }}
                        //required={}//make required if not value is set
                    />
                    <ToggleSwitch
                        label={"Aktiivinen"}
                        defaultChecked={strToBool(rule.in_use)}
                        onChange={()=>{
                            rule.in_use = toggleBoolean(rule.in_use)
                            setProgressStep(strToBool(rule.in_use) ? 3 : 1)
                        }}
                        className={"margin-top-sm"}
                    />
                </div>
                <div className={"margin-left flex-grow"}>
                    <TextInput
                        label={"Ilmoituksen nimi"}
                        value={textToShow(rule.text)}
                        onChange={val => {
                            setProgressStep(2)
                            rule.text = val
                        }}
                        placeholder={"Anna ilmoitukselle nimi"}
                        //required
                        // isValid={rule.text.length > 0}
                    />
                    <TextInput
                        label={"Kuvaus"}
                        value={textToShow(rule.comment)}
                        onChange={val => rule.comment = val}
                        placeholder={"Ilmoituksen kuvaus"}
                        multiline={2}
                        info={"Kuvaile ilmoitusta lyhyesti vastaanottajille"}
                    />
                </div>
            </div>
            <div>
            {rule.created ? <div className={"grid-container grid-2 msg msg-info margin-top"}>
                    <div>
                        <h6>Luotu</h6>
                        <p>{formatDate(rule[ATTR_CREATED_MS_I], true)}, {rule.created_by}</p>
                        <h6>Lähetetty</h6>
                        <p>{rule.stat_emails_sent}</p>
                    </div>
                    <div>
                        <h6>Muokattu</h6>
                        <p>{formatDate(rule[ATTR_UPDATED_MS_I], true)}, {rule.updated_by}</p>
                        <h6>Vastaanottajia</h6>
                        <p>{rule.stat_receivers?.length}</p>
                    </div>
                </div> : null}
            </div>
        </div>
        {renderReceivers()}
        {renderTriggers()}
        <Spacer size={"lg"}/>
        {USE_DEVELOPMENT_FEATURES ? <ProgressSteps step={progressStep} steps={progressSteps}/> : null}
    </>
}

//
// comment
//     :
//     "Ilmoituksen kommentti"
// created
//     :
//     "2023-02-09 09:29:57"
// created_by
//     :
//     "contact@thesamp.com"
// created_ms
//     :
//     1675934997554
// delay_minutes
//     :
//     0
// delay_minutes_minimum
//     :
//     5
// in_use
//     :
//     "Y"
// obj_id
//     :
//     "rule;7374a7d8-de4a-4096-b7f9-06562427dd9d"
// obj_state
//     :
//     "ACT"
// obj_type
//     :
//     "notif_rule"
// project_id
//     :
//     "5c675220-4676-484b-a017-46f27c0b3a9f"
// send_week_calendar
//     :
//     "n"
// sort_order
//     :
//     1675934997554
// stat_emails_sent
//     :
//     0
// stat_receivers
//     :
//     []
// text
//     :
//     "Eka ilmoitus"
// to_all_users
//     :
//     "Y"
// to_creator
//     :
//     "Y"
// to_emails
//     :
//     []
// to_muted
//     :
//     []
// to_tags
//     :
//     (2) ['Monta emailia', 'sahkopostiosoite']
// to_txts
//     :
//     []
// to_updater
//     :
//     "n"
// trig_created
//     :
//     "Y"
// trig_deleted
//     :
//     "n"
// trig_expiry_changed
//     :
//     "Y"
// trig_item_created
//     :
//     "n"
// trig_item_deleted
//     :
//     "n"
// trig_item_updated
//     :
//     "n"
// trig_updated
//     :
//     "n"
// trigger_attr_changed
//     :
//     ['hgfhfhghfghfgh fsdfsdfsdfsdf']
// updated_by
//     :
//     "contact@thesamp.com"
// updated_ms
//     :
//     1675934995554
// updated_str
//     :
//     "2023-02-09 09:29:57"